import React from 'react';
import './QuadImages.scss';

import { motion } from 'framer-motion';

import { Swiper, SwiperSlide } from 'swiper/react';
import { Autoplay } from 'swiper';
import 'swiper/css';

import topGoogle from '../../../assets/img/top-google.svg';
import top5stars from '../../../assets/img/top-5-stars.svg';
import topClutch from '../../../assets/img/top-clutch.svg';
import topAwwwards from '../../../assets/img/top-awwwards.svg';
import topCsswinner from '../../../assets/img/top-csswinner.svg';
import GradientButton from '../../../Library/GradientButton/GradientButton';

import { homePage } from '../../../editable-stuff/config';

export default function QuadImages() {
  const slides = [
    {
      img: topGoogle,
      title: "We're an affiliated Google Partner",
    },
    {
      img: top5stars,
      title: 'Consistently rated 5/5 stars',
    },
    {
      img: topClutch,
      title: 'Established, experienced, trusted UK based team',
    },
    {
      img: topAwwwards,
      title: 'Award Winning',
    },
    {
      img: topCsswinner,
      title: 'Bespoke web design and development (no templates)',
    },
    {
      img: topGoogle,
      title: "We're an affiliated Google Partner",
    },
    {
      img: top5stars,
      title: 'Consistently rated 5/5 stars',
    },
  ];

  return (
    <section id='quad-images' className='p-150'>
      <div className='container'>
        <div className='row align-items-center justify-content-between flex-lg-row-reverse'>
          <div className='col-12 col-lg-5'>
            <motion.div
              className='quad-image-block'
              initial={{ opacity: 0 }}
              whileInView={{ opacity: 1 }}
              transition={{ duration: 0.5 }}
            >
              <div className='single'>
                <img
                  loading='lazy'
                  src={homePage.section1.media.image.img}
                  alt='Web Design London'
                  width='298'
                  height='168'
                />
              </div>
              <div className='single'>
                <video
                  playsInline={true}
                  autoPlay={true}
                  muted={true}
                  loop={true}
                  src={homePage.section1.media.video1.video}
                  poster={homePage.section1.media.video1.img}
                  className=''
                />
              </div>
              <div className='single'>
                <video
                  playsInline={true}
                  autoPlay={true}
                  muted={true}
                  loop={true}
                  src={homePage.section1.media.video2.video}
                  poster={homePage.section1.media.video2.img}
                  className=''
                />
              </div>
              <div className='single'>
                <video
                  playsInline={true}
                  autoPlay={true}
                  muted={true}
                  loop={true}
                  src={homePage.section1.media.video3.video}
                  poster={homePage.section1.media.video3.img}
                  className=''
                />
              </div>
            </motion.div>
          </div>
          <div className='col-12 col-lg-5'>
            <div className='headers mb-4'>
              <motion.h4
                initial={{ x: '0px', opacity: 0 }}
                whileInView={{ x: '0', opacity: 1 }}
                transition={{ duration: 0.5 }}
              >
                {homePage?.section1.title}
              </motion.h4>
              <motion.h2
                initial={{ x: '-100px', opacity: 0 }}
                whileInView={{ x: '0', opacity: 1 }}
                transition={{ duration: 0.5 }}
                className='gradient'
              >
                {homePage?.section1.gradient_title}
              </motion.h2>
            </div>
            <motion.div
              initial={{ x: '-100px', opacity: 0 }}
              whileInView={{ x: '0', opacity: 1 }}
              transition={{ duration: 0.5 }}
              className='content'
            >
              {homePage?.section1.description?.map((descp) => (
                <p>{descp}</p>
              ))}
            </motion.div>
            <motion.div className='accred-swiper mt-4'>
              <Swiper
                spaceBetween={50}
                slidesPerView={1}
                loop={true}
                autoplay={{
                  delay: 3000,
                  disableOnInteraction: false,
                }}
                modules={[Autoplay]}
                // onSlideChange={() => console.log('slide change')}
                // onSwiper={(swiper) => console.log(swiper)}
              >
                {slides?.map((slide) => (
                  <SwiperSlide>
                    <img
                      className='swiper-lazy swiper-lazy-loaded'
                      loading='lazy'
                      alt='google partner'
                      src={slide.img}
                      width='100'
                      height='45'
                    />
                    <span>{slide?.title}</span>
                  </SwiperSlide>
                ))}
              </Swiper>
            </motion.div>
            <GradientButton
              text={homePage?.section1.button.text}
              link={homePage?.section1.button.link}
              svg='hand_shake'
            />
          </div>
        </div>
      </div>
    </section>
  );
}
